export const MODE = {
  HEATMAP: 'heatmap',
  DETECTIONS: 'detections',
};

export const TIME_MODE = {
  ALL: 'ALL',
  SELECTED: 'SELECTED',
};
